var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getAuthenticatedUserGroupLevel === '5' || _vm.getAuthenticatedUserGroupLevel === '6')?_c('div',[_c('BaseHeader',{attrs:{"title":_vm.$t('save_new_rental_car').toString()}}),_c('RentalCarForm')],1):_c('Forbidden')
}
var staticRenderFns = []

export { render, staticRenderFns }